/**
 * Generate and download a csv file
 * @constructor
 * @param {string} name - File name to download
 * @param {string} data - Csv content
 */
function generateCsv({ name, data }) {
  let csvFile = new Blob([data], { type: "text/csv" });
  let downloadLink = document.createElement("a");
  downloadLink.download = name || "atentus-file";
  downloadLink.href = window.URL.createObjectURL(csvFile);
  downloadLink.style.display = "none";

  document.body.appendChild(downloadLink);
  downloadLink.click();
}

export { generateCsv };
